module.exports = __webpack_public_path__ + "img/sutherapy_03.e2d2bd95.jpg";